import _isFunction from "lodash/isFunction";
import _isObjectLike from "lodash/isObjectLike";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../Icon';
import { useAutocomplete } from './useAutocomplete';
import { searchBarContainer, searchBarInputContainer, searchBarInput, searchBarInputIcon, searchBarSuggestionsContainer, searchBarSuggestionItem } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var SearchBar = function SearchBar(props) {
  var _props$displayKey = props.displayKey,
      displayKey = _props$displayKey === void 0 ? 'label' : _props$displayKey,
      className = props.className,
      renderInput = props.renderInput,
      renderSuggestionsContainer = props.renderSuggestionsContainer,
      renderSuggestion = props.renderSuggestion;

  var _useAutocomplete = useAutocomplete(props),
      inputProps = _useAutocomplete.inputProps,
      suggestionItemProps = _useAutocomplete.suggestionItemProps,
      isOpen = _useAutocomplete.isOpen,
      suggestions = _useAutocomplete.suggestions,
      rootNodeRef = _useAutocomplete.rootNodeRef;

  var listOfSuggestions = suggestions === null || suggestions === void 0 ? void 0 : suggestions.map(function (el, i) {
    var itemProps = _defineProperty({
      css: searchBarSuggestionItem,
      key: "suggestion-".concat(i),
      role: 'button',
      tabIndex: 0,
      onBlur: inputProps.onBlur,
      onClick: function onClick() {
        return suggestionItemProps.onClick(el);
      },
      onKeyDown: suggestionItemProps.onKeyDown
    }, suggestionItemProps.itemIdAttr, i);

    return _isFunction(renderSuggestion) ? renderSuggestion({
      itemProps: itemProps,
      suggestionItemProps: suggestionItemProps,
      item: el
    }) : ___EmotionJSX("div", itemProps, _isObjectLike(el) ? el[displayKey] : el);
  });
  return ___EmotionJSX("div", _extends({
    ref: rootNodeRef,
    css: searchBarContainer
  }, className && {
    className: className
  }), _isFunction(renderInput) ? renderInput({
    containerProps: {
      css: searchBarInputContainer
    },
    inputProps: _objectSpread({
      css: searchBarInput
    }, inputProps),
    iconProps: {
      iconName: 'las la-search',
      css: searchBarInputIcon
    }
  }) : ___EmotionJSX("div", {
    css: searchBarInputContainer
  }, ___EmotionJSX("input", _extends({
    css: searchBarInput
  }, inputProps)), ___EmotionJSX("label", {
    htmlFor: inputProps.id
  }, ___EmotionJSX(Icon, {
    iconName: "las la-search",
    css: searchBarInputIcon
  }))), _isFunction(renderSuggestionsContainer) ? renderSuggestionsContainer({
    isOpen: isOpen,
    suggestions: suggestions,
    css: searchBarSuggestionsContainer,
    children: listOfSuggestions
  }) : isOpen && !!(suggestions !== null && suggestions !== void 0 && suggestions.length) && ___EmotionJSX("div", {
    css: searchBarSuggestionsContainer
  }, listOfSuggestions));
};

SearchBar.propTypes = {
  inputRef: PropTypes.object,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  displayKey: PropTypes.string,
  renderInput: PropTypes.func,
  renderSuggestionsContainer: PropTypes.func,
  renderSuggestion: PropTypes.func
};
export default SearchBar;